import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { Subscription } from 'rxjs';
import { HeaderService } from '../../../../..//app/shared/_services/header.service';
import { ApiService } from '../../../../../app/shared/_services/api.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-cta-configuratore',
  templateUrl: './cta-configuratore.component.html',
  styles: []
})
export class CtaConfiguratoreComponent implements OnInit, OnDestroy {

  constructor(
    private api: ApiService,
    private router: Router,
    private localize: LocalizeRouterService,
    private header: HeaderService
    ) { }

  isMobile = window.innerWidth < environment.mobileBreakpoint;
  isHomepage = false;

  subs: Subscription[] = [];

  ngOnInit() {

    this.subs.push( this.header.setHomepage.subscribe(isHomepage => this.isHomepage = isHomepage) );

    this.isHomepage = this.router.url === `/${this.localize.parser.currentLang}`;
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

}
